import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {NavMenuButton as MenuButton} from '@apps-common/ui-components/NavBar';
import {THEME_MODE} from '@app/styles';

import ThemeModeIcon from '@mui/icons-material/DarkMode';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

import {trackEvent} from '@app/analytics';

const ThemeMenu = ({themeSwitch, setThemeSwitch}) => {
  const {t} = useTranslation();

  const handleThemeModeChange = e => {
    const newTheme = e.target.value;
    setThemeSwitch(newTheme);
    localStorage.setItem('pl-theme-mode', newTheme);
    trackEvent('Theme mode', {
      action: 'Updated',
      theme: newTheme,
    });
  };

  return (
    <>
      <MenuButton
        title={t('navbars.tooltipThemeMode', {
          theme: themeSwitch.charAt(0).toUpperCase() + themeSwitch.slice(1),
        })}
        label={<ThemeModeIcon fontSize="small" />}
        aria-label="theme-mode"
      >
        <Box mx={2} my={1}>
          <FormControl>
            <FormLabel>Appearance</FormLabel>
            <RadioGroup
              aria-labelledby="select-theme-mode"
              name="select-theme-mode"
              value={themeSwitch}
              onChange={e => handleThemeModeChange(e)}
            >
              <FormControlLabel
                value={THEME_MODE.SYSTEM}
                control={<Radio />}
                label="System OS (Default)"
              />
              <FormControlLabel
                value={THEME_MODE.LIGHT}
                control={<Radio />}
                label="Light"
              />
              <FormControlLabel
                value={THEME_MODE.DARK}
                control={<Radio />}
                label="Dark"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </MenuButton>
    </>
  );
};

ThemeMenu.propTypes = {
  themeSwitch: PropTypes.string,
  setThemeSwitch: PropTypes.func,
};

const mapDispatchProps = {};

export default connect(null, mapDispatchProps)(ThemeMenu);
